import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable: isDashboardAvailableCustomer } = useFlag(
  "DASHBOARD_OVERVIEW_CUSTOMER",
);
const DashboarPlatFormdModule = ({ registerNavItems }) => {
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  if (isDashboardAvailableCustomer.value) {
    registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
  }
};

export { DashboarPlatFormdModule };

export default {};
